import React, { useEffect, useState, useContext } from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { Button } from '@material-ui/core';
import ZonaForm from './ZonaForm'
import mZona from './Zona.controller'
import AuthContext from '../../context/auth-context'
import { isArray } from 'util'
import validate from 'validate.js'
import DialogInfo from '../../Dialog/DialogInfo'

const ZonaDetail = (props) => {
    const defaultPage = parseInt(props.match.params.page, 10);
    const defaultrowsPerPage = parseInt(props.match.params.rowsPerPage, 10);
    const kodeoutlet = props.match.params.kodeoutlet;
    const kodezona = props.match.params.kodezona;
    const { clientID, token } = useContext(AuthContext)
    const [OpenConfirmInfo, setOpenConfirmInfo] = useState(false)
    const [dialogtext, setDialogtext] = useState()
    const [dialogUrl, setDialogUrl] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const validateForm = () => {
        const { namazona, tarifongkir } = state;
        const promZona = new Promise((resolve, reject) => {
            const constraint = {
                namazona: {
                    length: {
                        minimum: 3,
                        message: "Nama Zona minimal terdiri dari 3 huruf"
                    },
                },
                tarifongkir: {
                    length: {
                        minimum: 1,
                        message: "Tarif Ongkir wajib isi"
                    },
                }
            }
            const validator = validate({ namazona, tarifongkir }, constraint, { fullMessages: false });
            if (validator === undefined) {
                resolve();
            } else {
                reject(validator);
            }
        })
        return Promise.all([promZona]);
    }
    const handleSimpan = () => {
        validateForm().then(() => {
            setIsLoading(true)
            mZona.updateZona(kodeoutlet, kodezona, state.namazona, state.tarifongkir, clientID, token).then(resp => {
                setIsLoading(false)
                if (resp) {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>${state.namazona} berhasil di update<p/>`)
                    setDialogUrl(`/manajemenoutlet/${kodeoutlet}/zona/${defaultPage}/${defaultrowsPerPage}`)
                } else {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>Server tidak dapat menjalankan perintah Anda saat ini. Silakan coba sesaat lagi<p/>`)
                }
            }).catch(err => {
                setIsLoading(false)
                if (isArray(err) && err.length > 0) {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>Gagal Simpan : ${err[0].message}<p/>`)
                } else if (typeof err == 'error') {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>${err.message}<p/>`)
                } else {
                    console.log(err);
                }
            })
        }).catch(err => {
            setIsLoading(false)
            const keys = Object.keys(err);
            var errorMessage = "";
            for (const key of keys) {
                errorMessage += err[key] + "\n";
            }
            setOpenConfirmInfo(true)
            setDialogtext(`<p>${errorMessage}<p/>`)
        })
    }
    const [state, setState] = useState({ kodezona: '', namazona: '' , tarifongkir: 0})
    useEffect(() => {
        var render = true;
        if (kodeoutlet && kodezona) {
            mZona.loadDetail(kodeoutlet, kodezona, clientID, token).then(resp => {
                if (render) setState(resp);
            })
        }
        return () => {
            render = false;
        };
    }, [kodeoutlet, kodezona, clientID, token])


    const handleChange = (key, value) => {
        const newState = Object.assign({}, state);
        newState[key] = value;
        setState(newState);
    }

    return (
        <Container>
            <ZonaForm type="edit" history={props.history} kodeoutlet={kodeoutlet} kodezona={state.kodezona} namazona={state.namazona} tarifongkir={state.tarifongkir} handleChange={handleChange} defaultPage={defaultPage} defaultrowsPerPage={defaultrowsPerPage} />
            <Row style={{ marginTop: 20, marginBottom: 20 }}>
                <Col xs={12} className="text-center">
                    <Button variant="contained" color="primary" onClick={handleSimpan} disabled={isLoading}>Update</Button>
                </Col>
            </Row>
            <DialogInfo open={OpenConfirmInfo} setOpen={setOpenConfirmInfo} text={dialogtext} url={dialogUrl} redirect={props.history.push} />
        </Container>
    )
}

export default ZonaDetail;